export abstract class ValidationScore {
  abstract countTotal(): number;
  abstract countInvalid(): number;
  abstract countValid(): number;
  abstract score(): number;
  abstract get missing(): string[];
}
